import { Record, Map } from 'immutable';
import { actionTypes } from './program-list.actions';
import { authActions } from '../../../auth';
import { Err } from '../../../err';

export const ProgramListState = Record({
  err: null,
  isFetching: false,
  isValid: false,
  programList: null
});

export const ProgramsState = Record({
  currentPage: 1,
  itemsPerPage: 25,
  sortBy: 'name',
  sortAsc: true,
  programListState: ProgramListState({})
});

export const programListReducer = (state = new Map(), action) => {
  switch (action.type) {
    case authActions.actionTypes.CREATE_ETO_SESSION_SUCCESS:
      return new Map({});
    case actionTypes.INIT_PROGRAM_DATA:
      if(action.siteId !== null) {
        const programsState = state.getIn([action.siteId, action.formId]);
        if(!programsState) {
          return state.setIn([action.siteId, action.formId], new ProgramsState({}));
        }
      }
      return state;
    case actionTypes.FETCH_PROGRAM_LIST_BEGIN:
      var modifiedState = state;
      if(action.siteId !== null) {
        const programsState = state.getIn([action.siteId, action.formId]);
        if(!programsState) {
          modifiedState = state.setIn([action.siteId, action.id], new ProgramsState({}));
        }
      }
      return modifiedState.setIn([action.siteId, action.formId, 'programListState'], new ProgramListState({
        isFetching: true
      }));
    case actionTypes.FETCH_PROGRAM_LIST_SUCCESS:
      return state.setIn([action.siteId, action.formId, 'programListState'], new ProgramListState({
        programList: action.data,
        isValid: true
      }));
    case actionTypes.FETCH_PROGRAM_LIST_FAILURE:
      return state.setIn([action.siteId, action.formId, 'programListState'], new ProgramListState({
        err: new Err(action.err),
        isValid: true
      }));
    case actionTypes.CHANGE_PAGE_NUMBER:
      return state.setIn([action.siteId, action.formId, 'currentPage'], action.page)
        .setIn([action.siteId, action.formId, 'programListState', 'isValid'], false);
    case actionTypes.CHANGE_SORT:
      return state.setIn([action.siteId, action.formId, 'sortBy'], action.sortBy)
        .setIn([action.siteId, action.formId, 'sortAsc'], action.sortAsc)
        .setIn([action.siteId, action.formId, 'programListState', 'isValid'], false);
    default:
      return state
  }
}
